// extracted by mini-css-extract-plugin
module.exports = {"btn":"ghostButton_btn__2Abn_","icon":"ghostButton_icon__3dYjU"};